import React, { Fragment, useEffect, useState } from "react";
// import { CustomColumnDef } from "./TableContainer"; // adjust path
import TableContainer, { CustomColumnDef } from "Common/TableContainer";
import { ColumnFiltersState, SortingState } from "@tanstack/react-table";
import axios from "axios";
import { Container } from "react-bootstrap";

type Product = {
  id: number;
  title: string;
  category: string;
  brand: string;
  price: number;
};

const ProductTablePage = () => {
  const [data, setData] = useState<Product[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sorting, setSorting] = useState<SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [colValue, setColValue] = useState<any>();

  useEffect(() => {
    console.log(`col Value in useEffect: ${colValue}`);
  }, [colValue]);
  const fetchData = async () => {
    const skip = pageIndex * pageSize;

    // Manual filters from columnFilters
    const titleFilter =
      columnFilters.find((f) => f.id === "title")?.value ?? "";
    const categoryFilter =
      columnFilters.find((f) => f.id === "category")?.value ?? "";

    const res: any = await axios.get(
      `https://dummyjson.com/products?limit=${pageSize}&skip=${skip}`
    );
    console.log("res: ", res);
    const allProducts: Product[] = res.products;

    const filtered = allProducts.filter(
      (p) =>
        p.title.toLowerCase().includes(String(titleFilter).toLowerCase()) &&
        p.category.toLowerCase().includes(String(categoryFilter).toLowerCase())
    );

    setData(filtered);
    setTotalRecords(res.total);
  };

  useEffect(() => {
    fetchData();
  }, [pageIndex, pageSize, sorting, columnFilters]);

  const columns: CustomColumnDef<Product>[] = [
    {
      accessorKey: "id",
      header: "ID",
    },
    {
      accessorKey: "title",
      header: "Title",
      filterType: "dropdown",
      filterOptions: ["smartphones", "laptops", "fragrances", "skincare,"],
    },
    {
      accessorKey: "category",
      header: "Category",
      filterType: "dropdown",
      filterOptions: [
        "Product 1 - smartphones",
        "Product 2 - laptops",
        "Product 3 - fragrances",
        "Product 4 - skincare",
        "Product 5 - smartphones",
        "Product 6 - laptops",
        "Product 7 - fragrances",
        "Product 8 - skincare",
        "Product 9 - smartphones",
        "Product 10 - laptops",
        "Product 11 - fragrances",
        "Product 12 - skincare",
        "Product 13 - smartphones",
        "Product 14 - laptops",
        "Product 15 - fragrances",
        "Product 16 - skincare",
        "Product 17 - smartphones",
        "Product 18 - laptops",
        "Product 19 - fragrances",
        "Product 20 - skincare",
        "Product 21 - smartphones",
        "Product 22 - laptops",
        "Product 23 - fragrances",
        "Product 24 - skincare",
        "Product 25 - smartphones",
        "Product 26 - laptops",
        "Product 27 - fragrances",
        "Product 28 - skincare",
        "Product 29 - smartphones",
        "Product 30 - laptops",
        "Product 31 - fragrances",
        "Product 32 - skincare",
        "Product 33 - smartphones",
        "Product 34 - laptops",
        "Product 35 - fragrances",
        "Product 36 - skincare",
        "Product 37 - smartphones",
        "Product 38 - laptops",
        "Product 39 - fragrances",
        "Product 40 - skincare",
        "Product 41 - smartphones",
        "Product 42 - laptops",
        "Product 43 - fragrances",
        "Product 44 - skincare",
        "Product 45 - smartphones",
        "Product 46 - laptops",
        "Product 47 - fragrances",
        "Product 48 - skincare",
        "Product 49 - smartphones",
        "Product 50 - laptops",
        "Product 51 - fragrances",
        "Product 52 - skincare",
        "Product 53 - smartphones",
        "Product 54 - laptops",
        "Product 55 - fragrances",
        "Product 56 - skincare",
        "Product 57 - smartphones",
        "Product 58 - laptops",
        "Product 59 - fragrances",
        "Product 60 - skincare",
        "Product 61 - smartphones",
        "Product 62 - laptops",
        "Product 63 - fragrances",
        "Product 64 - skincare",
        "Product 65 - smartphones",
        "Product 66 - laptops",
        "Product 67 - fragrances",
        "Product 68 - skincare",
        "Product 69 - smartphones",
        "Product 70 - laptops",
        "Product 71 - fragrances",
        "Product 72 - skincare",
        "Product 73 - smartphones",
        "Product 74 - laptops",
        "Product 75 - fragrances",
        "Product 76 - skincare",
        "Product 77 - smartphones",
        "Product 78 - laptops",
        "Product 79 - fragrances",
        "Product 80 - skincare",
        "Product 81 - smartphones",
        "Product 82 - laptops",
        "Product 83 - fragrances",
      ],
    },
    {
      accessorKey: "price",
      header: "Price",
    },
  ];

  return (
    <Fragment>
      <div className="page-content">
        <Container fluid>
          <TableContainer
            data={data}
            columns={columns}
            totalRecords={totalRecords}
            pageIndex={pageIndex}
            pageSize={pageSize}
            onPageChange={setPageIndex}
            onPageSizeChange={setPageSize}
            columnFilters={columnFilters}
            setColumnFilters={setColumnFilters}
            colValue={setColValue}
            sorting={sorting}
            onSortingChange={setSorting}
            manualSorting={true}
            isBordered={true}
            isPagination={true}
          />
        </Container>
      </div>
    </Fragment>
  );
};

export default ProductTablePage;
